import {Mutable, template as tpl} from "./mutable";
import {IRouteDefinitionParams, ISyncField} from "../../index";
import {global} from "../../appContext";
import {createErrorMessage, getObjectType} from "../../util/misc";
import {SPINNER} from "../../constants";
import {ISyncFieldMutable} from "./index";
import {nsSyncFields} from "../../req/nsSyncFields";
import {REQUEST_MESSAGE} from "../../constants/Language";

export let template: string = tpl;

export class viewModel extends Mutable {
    protected readonly reqSubmit = global.getPromiseRequest("createobject");

    constructor(params: IRouteDefinitionParams) {
        super(params);
        this.reqGetSyncFields = nsSyncFields.getSyncFields(this.__objectTypeId!);
        this.$original.type = getObjectType(this.__objectTypeId!);
        this.request();
    }

    protected request() {
        this.isReady(false);
        this.messageData({message: REQUEST_MESSAGE});

        Promise.resolve()
            .then(this.fetchSyncFields.bind(this))
            .then(this.onAllSyncFields.bind(this))
            .then(this.prepareObservableSyncFields.bind(this))
            .then(() => {
                this.messageData(null);
                this.isReady(true);
            })
            .catch((reason: string) => {
                this.messageData(createErrorMessage(String(reason)));
            });
    }

    protected prepareObservableSyncFields() {
        const mutableSyncFields: ISyncFieldMutable[] = this.allAvailableSyncfields
            .filter((sf: ISyncField) => sf.required)
            .map(this.createMutableFromSyncField.bind(this));
        mutableSyncFields.forEach(o => {
            this.__tabManager?.getTab('syncfieldsmandatory')?.errorManager.addErrorObject(o.errSyncfield)
            this.__tabManager?.getTab('syncfieldsmandatory')?.errorManager.addErrorObject(o.errValue)
        })
        this.data(mutableSyncFields);
    }

    protected override _isChanged(): boolean {
        return true;
    }

    protected override getSyncFieldSubmitData(): ISyncField[] {
        return this.data().map(this.mutableToStatic.bind(this));
    }

    protected getEventMessage(eventType: "submit" | "success") {
        switch (eventType) {
            case "submit":
                return `((creating|td)) ${SPINNER}`
            case "success":
                const ret: string[] = ['subject is created|s:']
                if (this.__routeDef.manual) {
                    ret.push('((manual)) ')
                }
                ret.push(`((${this.__objDef?.translation ?? ''}))`)
                return ret.join('')
        }
    }

}
